import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { selectUserPreferences } from 'redux/selectors';
import { selectUserPreference } from 'redux/UserPreferences';
import { ExportIcon } from 'components/icons';
import IconButton from 'components/shared/IconButton';
import { reformatExportChartData, reformatExportChartSetData } from './utils';

function ChartSetPreferenceExport({ chartSet }) {
  const charts = useSelector((state) => {
    const chartSetChartPreferenceIds = chartSet?.state?.charts?.map((chart) => chart.preferenceId);
    const allCharts = [];
    chartSetChartPreferenceIds.forEach((preferenceId) => {
      const chart = selectUserPreference(selectUserPreferences(state), preferenceId);
      allCharts.push(chart);
    });
    return allCharts;
  });

  const handleExportJsonFile = useCallback(() => {
    // remove all createdDt, modifiedDt, userId, and preferenceId from the chartSet and charts data
    // reset all default values to FALSE
    const chartSetData = {
      chartSet: reformatExportChartSetData(chartSet),
      charts: charts.map((chart) => reformatExportChartData(chart))
    };

    const fileName = `chart_set-${chartSet?.name?.split(' ').join('_') || 'exported'}.json`;
    const jsonString = `data:text/json;chatset=utf-8,${encodeURIComponent(JSON.stringify(chartSetData, null, 4))}`;

    const link = document.createElement('a');
    link.href = jsonString;
    link.download = fileName;

    link.click();
  }, [chartSet, charts]);

  return (
    <IconButton
      aria-label="Export"
      data-tip="Export Chart Set"
      variant="text"
      color="primary"
      size="x-small"
      onClick={handleExportJsonFile}
    >
      <ExportIcon />
    </IconButton>
  );
}

export default ChartSetPreferenceExport;
